import { render, staticRenderFns } from "./ProductModifier.vue?vue&type=template&id=6e56914b&"
import script from "./ProductModifier.vue?vue&type=script&lang=js&"
export * from "./ProductModifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports